import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { isFreePlan } from '../../../utils/planUtils';
import Button from 'material-ui/Button';
import Setting from '../../Icons/Setting';
import ArrowToolTip from "../../common/ArrowToolTip";

const styles = () => ({
  icon: {
    border: "1px solid #D8DBDF",
    marginRight: "20px",
    fontSize: "15px",
    height: "33px",
    width: '36px',
    boxSizing: "border-box",
    minWidth: "unset",
    padding: 0,
  },
});

class ListSettingButton extends React.Component {
  render() {
    const { classes, user } = this.props;

    return (
      <ArrowToolTip text="表示設定">
        <Button
          className={classes.icon}
          onClick={isFreePlan(user) ? this.props.togglePlanDialog : this.props.toggleListSettingDialog}>
          <Setting width={20} height={20} color="#B1B3B9" />
        </Button>
      </ArrowToolTip>
    );
  }
}

ListSettingButton.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  user: PropTypes.object,
  togglePlanDialog: PropTypes.func.isRequired,
  toggleListSettingDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(ListSettingButton);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/parts/ListSettingButton.jsx